import { render } from "./FlowForm.vue?vue&type=template&id=0722ea94"
import script from "./FlowForm.vue?vue&type=script&lang=js"
export * from "./FlowForm.vue?vue&type=script&lang=js"

import "./FlowForm.vue?vue&type=style&index=0&id=0722ea94&lang=css"

import exportComponent from "/home/tadam/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__